import Loadable from "app/components/Loadable";
import { lazy } from "react";

const AppPage = Loadable(lazy(() => import("./AppPage")));
const InstallPage = Loadable(lazy(() => import("./InstallPage")));
const InstallResultPage = Loadable(lazy(() => import("./InstallResultPage")));
const UninstallPage = Loadable(lazy(() => import("./UninstallPage")));
const DeveloperModePage = Loadable(lazy(() => import("./DeveloperModePage")));
const ApplicationOrderPage = Loadable(lazy(() => import("./ApplicationOrderPage")));

const appRoutes = [
  { path: "app/:id", element: <AppPage /> },
  { path: "apps/:id/install", element: <InstallPage /> },
  { path: "apps/:id/install-result", element: <InstallResultPage /> },
  { path: "apps/:id/uninstall", element: <UninstallPage /> },
  { path: "developer-mode", element: <DeveloperModePage /> },
  { path: "application-order", element: <ApplicationOrderPage /> },
];

export default appRoutes;
